import { createContext } from "react"
import { Theme } from "@mui/material"
import { Css, Cx } from "tss-react"
import { StylesClasses } from "./styles"

type TableStyleContextType = {
  classes: Record<StylesClasses, string>
  theme: Theme
  css: Css
  cx: Cx
}

const TableStyleContext = createContext<TableStyleContextType>(null)

export default TableStyleContext
